module.exports = __webpack_public_path__ + "img/contact-bjornhaulin.0b269e4d.png";